module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "figcenter1",
    attrs: {
      "id": "frontispiz"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Frontispiz: Sven Hedin in   kaiserlicher Uniform",
      "id": "id-3064535589832948675",
      "src": "Images/img0001.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "linkedimage"
  }, [_c('span', {
    attrs: {
      "id": "frontispiz_gross"
    }
  }, [_vm._v("⇒"), _c('br', {
    staticClass: "calibre8"
  }), _vm._v(" "), _c('span', {
    staticClass: "s1"
  }, [_vm._v("GRÖSSERES BILD")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0